import * as React from 'react';

export const cnFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_11_4446)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#EF1520'
            />
            <path
                d='M25.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V17.3333C0 18.8061 1.19391 20 2.66667 20H25.3333C26.8061 20 28 18.8061 28 17.3333V2.66667C28 1.19391 26.8061 0 25.3333 0Z'
                fill='#EF1520'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.33082 9.64L5.37082 10.6707L5.74416 8.488L4.16016 6.94133L6.35082 6.62533L7.33082 4.63867L8.30949 6.62533L10.5002 6.94133L8.91349 8.488L9.28949 10.6693L7.33082 9.64ZM12.0002 4H13.3335V5.33333H12.0002V4ZM13.3335 6.66667H14.6668V8H13.3335V6.66667ZM13.3335 9.33333H14.6668V10.6667H13.3335V9.33333ZM12.0002 12H13.3335V13.3333H12.0002V12Z'
                fill='#FFFF00'
            />
        </g>
        <defs>
            <clipPath id='clip0_11_4446'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
